/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostFigmaFileBody,
  PostFigmaFileStructureBody,
  PostFigmaFilePagesBody,
  PostFigmaFilePagesCheckBody,
  PostFigmaFileNodesBody,
  PostFigmaFileIterationBody,
  PostFigmaFileCheckBody,
  PostFigmaFileResponse,
  PostFigmaFileStructureResponse,
  PostFigmaFilePagesResponse,
  PostFigmaFilePagesCheckResponse,
  PostFigmaFileNodesResponse,
  PostFigmaFileIterationResponse,
  PostFigmaFileCheckResponse,
} from '../types';

export class Figma extends Controller {
  async postFigmaFile<
    T extends PostFigmaFileResponse,
    D,
    C extends PostFigmaFileBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file',
      body,
      axiosConfig
    );
  }

  async postFigmaFileStructure<
    T extends PostFigmaFileStructureResponse,
    D,
    C extends PostFigmaFileStructureBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file/structure',
      body,
      axiosConfig
    );
  }

  async postFigmaFilePages<
    T extends PostFigmaFilePagesResponse,
    D,
    C extends PostFigmaFilePagesBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file/pages',
      body,
      axiosConfig
    );
  }

  async postFigmaFilePagesCheck<
    T extends PostFigmaFilePagesCheckResponse,
    D,
    C extends PostFigmaFilePagesCheckBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file/pages/check',
      body,
      axiosConfig
    );
  }

  async postFigmaFileNodes<
    T extends PostFigmaFileNodesResponse,
    D,
    C extends PostFigmaFileNodesBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file/nodes',
      body,
      axiosConfig
    );
  }

  async postFigmaFileIteration<
    T extends PostFigmaFileIterationResponse,
    D,
    C extends PostFigmaFileIterationBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file/iteration',
      body,
      axiosConfig
    );
  }

  async postFigmaFileCheck<
    T extends PostFigmaFileCheckResponse,
    D,
    C extends PostFigmaFileCheckBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/figma/file/check',
      body,
      axiosConfig
    );
  }
}
